import { useState, useEffect } from 'react';

const useTimer = (stageTime) => {
  const [stageTimeleft, setStageTimeleft] = useState(stageTime);

  useEffect(() => {
    let timer;
    if (stageTimeleft > 0) {
      timer = setTimeout(() => {
        setStageTimeleft(stageTimeleft - 1000);
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [stageTimeleft]);

  return stageTimeleft;
};

export default useTimer;
